import React, {useContext, useEffect} from "react";
import {UIStoreContext} from "../../context";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router-dom";

import styles from "./DeviceItem.module.scss";
import {DateTime} from "luxon";
import green_v from "./icons/green.svg";
import green_r from "./icons/green_r.svg";
import red_r from "./icons/red_r.svg";
import {SystemType} from "../../common/systemType";
import deviceManagementService from "../../client-api/services/deviceManagement";


export interface DeviceItemInterface {
    device_name: Object;
    id: string;
    last_active: number;
    status: string;
    connection_state: any;
}


const DeviceItem = ({item, onPingStatusChange, pingStatus}: any) => {
    const uiStore = useContext(UIStoreContext);
    const navigate = useNavigate()
    
    // Call ping for this device
    const pingResponse = deviceManagementService.ping(item.id);

    function parseDate(dateValue: any,) {
        return dateValue != "" ? DateTime.fromMillis(dateValue * 1000).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS) : "--";
    }

    const gotoEventsReport = (id: string) => {
        uiStore.setMapDrawerOpen(false);
        uiStore.setSelectedSystem(id);
        uiStore.setCurrentPage("Events");
        navigate("../performanceReport");

    };

    // Use ping status from parent if available, then from response, then fall back to connection_state
    const isOnline = pingStatus !== undefined 
        ? pingStatus
        : (pingResponse?.isSuccess && pingResponse?.data?.status !== undefined 
            ? pingResponse.data.status === 200 
            : (item.connection_state === 'Connected'));

    const lastActive = pingResponse?.isSuccess && pingResponse?.data?.last_active !== "" ? pingResponse?.data.last_active : "";
;    // Report ping status to parent component
    useEffect(() => {
        if (pingResponse?.isSuccess && pingResponse?.data?.status !== undefined && onPingStatusChange) {
            onPingStatusChange(item.id, pingResponse.data.status === 200);
        }
    }, [pingResponse?.isSuccess, pingResponse?.data?.status, item.id, onPingStatusChange]);

    return (
        <div className={`${styles.deviceItem}`} onClick={() => gotoEventsReport(item.id)}>
            <div className={`${styles.deviceItemTitleContainer}`}>
                <img
                    src={isOnline ? green_r : red_r}
                    alt={"Connection State"}
                />
                <div className={`${styles.deviceNameTitle}`}>{(item.loco_name).toUpperCase()}
                </div>

            </div>

            <div
                className={(item.device_type === SystemType.SwitchYard.valueOf()) ? `${styles.deviceItemImageSY}` : `${styles.deviceItemImageML}`}>

            </div>
            <div className={`${styles.deviceInfoContainer}`}>
                <div className={`${styles.deviceInfoTop}`}>
                    <div
                        className={`${styles.deviceItemInfoText}`}>Ready
                    </div>
                    <div className={`${styles.deviceItemInfoText}`}>
                        <img
                            src={green_v}
                            alt={"Activity Status"}
                        />
                    </div>
                </div>
                <div className={`${styles.deviceInfoBottom}`}>
                    <div
                        className={`${styles.deviceItemInfoTextBottom}`}>Last
                        seen
                    </div>
                    <div
                        className={`${styles.deviceItemInfoTextBottom}`}>{parseDate(lastActive)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(DeviceItem)